//import _ from 'lodash';

import reports from '@/api/reports';
import * as types from '@/store/mutation-types';
import { saveBlobToFile } from '@/utils/fileHelpers';

const state = {
  loading: null,
  reports: []
};

const getters = {
  LoadingReports: state => state.loading,
  Reports: state => state.reports
};

const actions = {
  async getReports({ commit, state }) {
    commit(types.SET_LOADING_REPORTS_STATE, true);

    try {
      const response = await reports.getReports();

      commit(types.SET_REPORTS_LIST, response);
    } catch (error) {
      console.log(error);
      throw error;
    }

    commit(types.SET_LOADING_REPORTS_STATE, false);

    return state.reports;
  },
  downloadReport(context, report) {
    return new Promise((resolve, reject) => {
      reports
        .downloadReport(report)
        .then(response => {
          const blob = new Blob([response.data], { type: response.headers['content-type'] });
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          let disposition = null;
          if (response.headers['content-disposition']) {
            disposition = response.headers['content-disposition'];
          }
          let matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            saveBlobToFile(blob, matches[1].replace(/['"]/g, ''));
          }
          resolve();
        })
        .catch(error => reject(error));
    });
  }
};

const mutations = {
  [types.SET_LOADING_REPORTS_STATE](state, loading) {
    state.loading = loading;
  },
  [types.SET_REPORTS_LIST](state, reports) {
    state.reports = reports.data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
